export default __webpack_public_path__ + "media/zurb/img/services/tools/sketching-screenshot1-502ccf2d5e82e6b99c218f3ad3bf59c9.png";